import { render, staticRenderFns } from "./AJDAddCmp.vue?vue&type=template&id=2355b3fd"
import script from "./AJDAddCmp.vue?vue&type=script&lang=js"
export * from "./AJDAddCmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2355b3fd')) {
      api.createRecord('2355b3fd', component.options)
    } else {
      api.reload('2355b3fd', component.options)
    }
    module.hot.accept("./AJDAddCmp.vue?vue&type=template&id=2355b3fd", function () {
      api.rerender('2355b3fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/basicData/cope/quotationManagement/cmp/AJDCmp/AJDAddCmp.vue"
export default component.exports